var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMAsistenciaRemota(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3024_129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52 26L43.8642 17.8641V34.1358L52 26Z",
    fill: "#2ECCB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 0L20.9408 5.05917H31.0592L26 0Z",
    fill: "#2ECCB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 26L8.13583 34.1358V17.8641L0 26Z",
    fill: "#2ECCB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 52L31.0592 46.9409H20.9408L26 52Z",
    fill: "#2ECCB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0308 7.03082H10.1075V44.9692H41.8817V7.03082H33.0308ZM26 10.9742C32.5433 10.9742 37.8733 16.3042 37.8733 22.8475C37.8733 29.3908 32.5433 34.7208 26 34.7208C19.4567 34.7208 14.1267 29.3908 14.1267 22.8475C14.1267 16.3042 19.4567 10.9742 26 10.9742ZM19.9333 40.8417H14.1808V38.87H19.9333V40.8417ZM28.8817 40.8417H23.1292V38.87H28.8817V40.8417ZM37.8192 40.8417H32.0667V38.87H37.8192V40.8417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0592 5.05914L32.045 6.04498L33.0308 7.03081H41.8817V15.8816L42.8783 16.8783L43.8642 17.8641V5.05914H31.0592Z",
    fill: "#329BE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8783 35.1217L41.8817 36.1184V44.9692H33.0308L32.045 45.955L31.0592 46.9409H43.8642V34.1359L42.8783 35.1217Z",
    fill: "#329BE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.955 45.955L18.9692 44.9692H10.1075V36.1075L9.12167 35.1217L8.13583 34.1359V46.9409H20.9408L19.955 45.955Z",
    fill: "#329BE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.13583 5.05914V17.8641L9.12167 16.8783L10.1075 15.8925V7.03081H18.9692L19.955 6.04498L20.9408 5.05914H8.13583Z",
    fill: "#329BE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9692 44.9692L19.955 45.955L20.9408 46.9408H31.0592L32.045 45.955L33.0308 44.9692H18.9692Z",
    fill: "#0B5C96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.045 6.04498L31.0592 5.05914H20.9408L19.955 6.04498L18.9692 7.03081H33.0308L32.045 6.04498Z",
    fill: "#0B5C96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8783 16.8783L41.8817 15.8817V36.1183L42.8783 35.1217L43.8642 34.1358V17.8642L42.8783 16.8783Z",
    fill: "#0B5C96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.12167 16.8784L8.13583 17.8642V34.1359L9.12167 35.1217L10.1075 36.1075V15.8925L9.12167 16.8784Z",
    fill: "#0B5C96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 12.9567C20.54 12.9567 16.1092 17.3983 16.1092 22.8475C16.1092 28.2967 20.5508 32.7383 26 32.7383C31.4492 32.7383 35.8908 28.2967 35.8908 22.8475C35.8908 17.3983 31.4492 12.9567 26 12.9567ZM29.2067 26.4333L28.2642 27.3867C28.145 27.5058 27.9392 27.5167 27.82 27.3867L24.6458 24.2558C24.5808 24.2017 24.5483 24.115 24.5483 24.0283V16.9325C24.5483 16.7592 24.6892 16.6183 24.8625 16.6183H26.2058C26.3792 16.6183 26.52 16.7592 26.52 16.9325V23.3242L29.1958 25.9675C29.315 26.0867 29.3258 26.2925 29.1958 26.4117L29.2067 26.4333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 10.9742C19.4567 10.9742 14.1267 16.3042 14.1267 22.8475C14.1267 29.3908 19.4567 34.7208 26 34.7208C32.5433 34.7208 37.8733 29.3908 37.8733 22.8475C37.8733 16.3042 32.5433 10.9742 26 10.9742ZM26 32.7383C20.54 32.7383 16.1092 28.2967 16.1092 22.8475C16.1092 17.3983 20.5508 12.9567 26 12.9567C31.4492 12.9567 35.8908 17.3983 35.8908 22.8475C35.8908 28.2967 31.4492 32.7383 26 32.7383Z",
    fill: "#0B5C96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1808 38.8592V39.845V40.1809V40.8417H14.8417H19.9333V38.8592H14.1808Z",
    fill: "#329BE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1183 38.8592V40.8417H28.8817V39.845H23.1183H28.8817V38.8592H23.1183Z",
    fill: "#329BE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0667 38.8592V40.8417H37.1583H37.8192V40.1809V39.845V38.8592H32.0667Z",
    fill: "#329BE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5308 23.3458V16.9542C26.5308 16.7808 26.39 16.64 26.2167 16.64H24.8733C24.7 16.64 24.5592 16.7808 24.5592 16.9542V24.05C24.5592 24.1367 24.5917 24.2125 24.6567 24.2775L27.8308 27.4083C27.95 27.5275 28.1558 27.5275 28.275 27.4083L29.2175 26.455C29.3367 26.3358 29.3367 26.13 29.2175 26.0108L26.5417 23.3675L26.5308 23.3458Z",
    fill: "#329BE6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3024_129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMAsistenciaRemota);
export default __webpack_public_path__ + "static/media/m_asistencia_remota.e1a8af79974e047ddb785df36545a609.svg";
export { ForwardRef as ReactComponent };